module.exports = "<div class=\"invalid-feedback-cst\">\r\n  <span *ngIf=\"messgae\">{{messgae}}</span>\r\n</div>\r\n"